<template>
	<AppHeader />
	<slot />
	<AppFooter v-if="showFooter" />

	<CharacterModal :character="currentCharacter" modal-id="character" />
	<ProductModal :product="currentProduct" modal-id="product" />
	<ContactModal modal-id="question" />
	<QRCodeModal :qr-code="qrCode" modal-id="qr-code" />

	<svg class="sr-only">
		<clipPath id="home-hero-card" clipPathUnits="objectBoundingBox">
			<path
				d="M0.418,0.052 C0.383,0.03,0.345,0,0.296,0 L0.098,0 C0.044,0,0,0.029,0,0.065 L0,0.936 C0,0.972,0.044,1,0.098,1 L0.902,1 C0.956,1,1,0.972,1,0.936 L1,0.065 C1,0.029,0.956,0,0.902,0 L0.699,0 C0.65,0,0.612,0.03,0.576,0.052 C0.556,0.065,0.528,0.072,0.497,0.072 C0.467,0.072,0.439,0.065,0.418,0.052"
				fill="black"
			/>
		</clipPath>
	</svg>
</template>

<script>
import 'vue-final-modal/style.css'
import '@/assets/landing/scss/index.scss'
import AppHeader from '@/components/landing/AppHeader.vue'
import AppFooter from '@/components/landing/AppFooter.vue'
import CharacterModal from '@/components/landing/modals/CharacterModal.vue'
import ProductModal from '@/components/landing/modals/ProductModal.vue'
import ContactModal from '@/components/landing/modals/ContactModal.vue'
import QRCodeModal from '@/components/landing/modals/QRCodeModal.vue'
import { mapState, mapActions } from 'pinia'
import { useCharactersStore } from '@/stores/landing/characters.js'
import { useProductsStore } from '@/stores/landing/products.js'
import { useMarketsStore } from '@/stores/landing/markets.js'
import { useNewsStore } from '@/stores/landing/news.js'
import useBreakpoints from '@/composables/landing/useBreakpoints.js'
import generateQR from '@/helpers/generateQR.js'
import { boolean } from 'smooth-scrollbar/decorators'

export default {
	name: 'HomeView',
	components: {
		AppHeader,
		AppFooter,
		CharacterModal,
		ProductModal,
		ContactModal,
		QRCodeModal
	},
	props: {
		showFooter: {
			type: Boolean,
			default: true,
		},
	},
	provide() {
		return {
			showCharacter: this.showCharacter,
			showProduct: this.showProduct,
			showQRCode: this.showQRCode
		}
	},
	setup() {
		useBreakpoints()
	},
	data() {
		return {
			currentCharacter: null,
			currentProduct: null,
			qrCode: ''
		}
	},
	computed: {
		...mapState(useCharactersStore, {
			characters: 'characters'
		}),
		...mapState(useProductsStore, {
			products: 'products'
		})
	},
	created() {
		this.fetchCharacters()
		this.fetchProducts()
		this.fetchMarkets()
		this.fetchNews()
	},
	methods: {
		...mapActions(useCharactersStore, {
			fetchCharacters: 'fetchCharacters',
			setCurrentCharacter: 'setCurrentCharacter'
		}),
		...mapActions(useProductsStore, {
			fetchProducts: 'fetchProducts'
		}),
		...mapActions(useMarketsStore, {
			fetchMarkets: 'fetchMarkets'
		}),
		...mapActions(useNewsStore, {
			fetchNews: 'fetchNews'
		}),
		showCharacter(character) {
			this.currentCharacter = character
			this.$vfm.open('character')
		},
		showProduct(product) {
			this.currentProduct = product
			this.$vfm.open('product')
		},
		async showQRCode() {
			if (!this.qrCode) {
				this.qrCode = await generateQR(`${window.location.origin}/scene`)
			}
			this.$vfm.open('qr-code')
		}
	}
}
</script>
